var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchAvaWebAppSession } from './index';
import { startConversationReadClient } from '../conversation';
import { getSocketIfExist, createV1Socket } from '../../utils/getSocket';
export const reconnectToWebSocket = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    // eslint-disable-next-line no-console
    const ws = getSocketIfExist();
    if (ws)
        ws.close();
    const { scribeConversation, scribeSession } = getState();
    const { currentPlatform } = scribeSession;
    dispatch({ type: 'RETRY_RECONNECT_WEBSOCKET' });
    const { reconnectionWsUrl, scribe, status } = scribeConversation;
    const { captioner } = scribeSession;
    if (reconnectionWsUrl) {
        dispatch({ type: 'CONSUME_RECONNECTION_WS_URL' });
        yield createV1Socket(reconnectionWsUrl, Object.assign(Object.assign({}, captioner), { parse: captioner }), {
            roomId: status.id,
            scribe,
        });
    }
    else {
        yield fetchAvaWebAppSession()(dispatch, getState);
    }
    startConversationReadClient()(dispatch, getState);
});
export const setShouldShowReconnectingBanner = (shouldShow) => ({
    type: 'SET_SHOULD_SHOW_RECONNECTING_BANNER',
    payload: shouldShow,
});
export const setWebsocketStatus = (status) => ({
    type: 'SET_WEBSOCKET_STATUS',
    payload: status,
});
